module.exports = __webpack_public_path__ + "static/rainbowspot4-0d3b763cad1bc18fcbd6f289dc96cff1.png";